import { FC, useEffect, useState } from 'react';
import loadable from '@loadable/component';
import { useIsVisible } from '#baseAgeGate/hooks';

const AgeGate = loadable(() => import('#baseAgeGate/containers'), {
  resolveComponent: ({ AgeGate: Component }) => Component,
});

const AgeGateWrapper: FC = () => {
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const isVisible = useIsVisible();

  useEffect(() => {
    if (isLoaded || !isVisible) {
      return;
    }

    AgeGate.load().then(() => {
      setIsLoaded(true);
    });
  }, [isLoaded, isVisible]);

  if (!isLoaded) {
    return null;
  }

  return <AgeGate />;
};

export { AgeGateWrapper };
